import { render, staticRenderFns } from "./TeamListAddNew.vue?vue&type=template&id=bad16dda&"
import script from "./TeamListAddNew.vue?vue&type=script&lang=js&"
export * from "./TeamListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./TeamListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports